import {BREAKPOINTS} from '../../const';
import useBreakpoint from '../dom/useBreakpoint';

const useCreateReportOrWorkspaceButton = ({maxLimitReached, onClick, tooltipTitle}) => {
  const currentBreakpoint = useBreakpoint();
  const responsive = [BREAKPOINTS.xs, BREAKPOINTS.sm, BREAKPOINTS.md].includes(currentBreakpoint);

  const handleClick = () => {
    if (maxLimitReached) return;
    if (onClick) onClick();
  };

  return {
    responsive,
    handleClick,
    tooltipTitle
  };
};

export default useCreateReportOrWorkspaceButton;
